module.exports = __webpack_public_path__ + "static/media/scan.bb7e1b03.png";